import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import loginWithEtToken from '../services/loginWithEtToken';
import loginWithFirebaseToken from '../services/loginWithFirebaseToken';
import getAuthPortalRedirectUrl from '../helpers/getAuthPortalRedirectUrl';
export default function startApplication(_x) {
  return _startApplication.apply(this, arguments);
}

function _startApplication() {
  _startApplication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(app) {
    var firebaseTokenLogin, etTokenLogin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return loginWithFirebaseToken(app);

          case 3:
            firebaseTokenLogin = _context.sent;

            if (!firebaseTokenLogin) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", null);

          case 6:
            _context.next = 8;
            return loginWithEtToken(app);

          case 8:
            etTokenLogin = _context.sent;

            if (!etTokenLogin) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", null);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0); // eslint-disable-next-line no-console

            console.log(_context.t0);

          case 16:
            return _context.abrupt("return", window.location.assign(getAuthPortalRedirectUrl()));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));
  return _startApplication.apply(this, arguments);
}